angular.module('qkr').controller('dashboardController', ($scope, $rootScope, $routeSegment, outletService,
                                                         merchantService, $location, appConfig) => {
	$scope.dashboardInfo;
	$scope.dashboardInfoLoaded = false;
	$scope.onboardingInfo = {};
	$scope.onboardingInfoLoaded = false;
	$scope.isDisabled = 'orange';
	$scope.inventoryIsOpen = false;
	$scope.storefrontIsOpen = false;
	$scope.settingIsOpen = false;
	$scope.paymentIsOpen = false;
	$scope.merchantInfo;
	$scope.isReportManager = appConfig.isReportManager;
	$scope.username = appConfig.username;
	$scope.firstName = appConfig.firstName;
    $scope.messages = [];
	
	// Call on page load
	$scope.init = function() {
		$scope.$routeSegment = $routeSegment; // Used to know what we've
		// Selected

        outletService.loadDashboardInfo().then((promise) => {
			$scope.dashboardInfo = promise;
			$scope.dashboardInfoLoaded = true;
			$rootScope.undefinedFamilyNumbers = $scope.dashboardInfo.numUndefinedFamilyNumbers;
	        $rootScope.undefinedProducts = $scope.dashboardInfo.numUncategorisedProducts;
            if (merchantService.behaviour(merchantService.merchantInfo, 'dashboardPage.showDepts')) {
                $scope.menuLink = '#/departments';
            } else {
                $scope.menuLink = '#/newmenus';
            }
		});
		
		outletService.loadOnboardingInfo().then((promise) => {
			$scope.onboardingInfo = promise;
			
			outletService.loadOutlet().then((promise) => {
                $scope.outletInfo = promise;
			});

			$scope.onboardingInfoLoaded = true;

            $scope.chart = {};

			$scope.chart.data = {
				series: ['OnBoarding'],
				data: [{
					x: 'Complete',
					y: [promise.percentComplete]
				}, {
					x: 'Incomplete',
					y: [100 - promise.percentComplete]
				}]
			};

			$scope.chart.config = {
				colors: ['#82b238', '#FFA500'],
				tooltips: false,
				labels: false,
				legend: {
					display: false,
					position: 'right'
				},
				click(d) {
					$scope.messages.push('clicked!');
				},
				mouseover(d) {
					$scope.messages.push('mouseover!');
				},
				mouseout(d) {
					$scope.messages.push('mouseout!');
				}
			};
		});
	},

	$scope.positive = function(task) {
		if (task.percentComplete == 0) {
			return 'red';
		} else if (task.percentComplete < 100) {
			return 'orange';
		} else {
			return 'green';
		}
	},

	$scope.isTaskCompleted = function(task) {
		return task.percentComplete == 100;
	},

	// The product list has been reloaded
	$rootScope.$on('reloadDashboard', (evt) => {
        outletService.loadDashboardInfo().then((promise) => {
			$scope.dashboardInfo = promise;
			$rootScope.undefinedFamilyNumbers = $scope.dashboardInfo.numUndefinedFamilyNumbers;
	        $rootScope.undefinedProducts = $scope.dashboardInfo.numUncategorisedProducts;
		});
		outletService.loadOnboardingInfo().then((promise) => {
			$scope.onboardingInfo = promise;
			$rootScope.undefinedFamilyNumbers = $scope.dashboardInfo.numUndefinedFamilyNumbers;
	        $rootScope.undefinedProducts = $scope.dashboardInfo.numUncategorisedProducts;
		});
	});

	$scope.setIsOpen = function(link) {
		if (link) {
            $location.path(link);

            if (link.indexOf('/inventory') !== -1) {
                $rootScope.$broadcast('inventoryIsOpen', true);
                $scope.inventoryIsOpen = true;
            }

            if (link.indexOf('/departments') !== -1 || link.indexOf('/storefront') !== -1) {
                $rootScope.$broadcast('storefrontIsOpen', true);
                $scope.storefrontIsOpen = true;
            }

            if (link.indexOf('/paymentgateway') !== -1 || link.indexOf('/beneficiary') !== -1) {
                $rootScope.$broadcast('settingIsOpen', true);
                $scope.paymentIsOpen = true;
            }
		}
	};

    $scope.hideProduct = function(link) {
        if (link && link.indexOf('/inventory') !== -1) {
            return merchantService.behaviour($rootScope.merchantInfo, 'dashboardPage.hideProduct');
        }
    };
});



// WEBPACK FOOTER //
// ./src/controllers/dashboard.controller.js